/* 引入vuex，这里是独立的js文件，因此需要引入js文件而不是vuex */
import io from 'socket.io-client'
import whatsAppSocket from '@/utils/whatsAppSocket'
let socket
export function createConnect() {
  const url = process.env.VUE_APP_SOCKET_URL
  if (socket) return socket
  return socket = io(url, {
    path: '/watool/socket.io',
    query: {
      platform: 'kefu', // 没啥用 后台非得要
      //   id: store.getters.staffInfo.id,
      //   xtoken: getToken('X-Token'),
      EIO: 3
    },
    reconnectionDelayMax: 10000,
    transports: ['websocket']
  })
}

/**
 * @Description: 断开socket连接
 * @name: disconnect
 * @param {*}
 * @return {*}
 */
export function disconnect(sk) {
  sk = sk || socket
  sk.close()
}

export function nextDelayTime(attempts) {
  return (Math.pow(2, attempts) * 1000) + Math.floor(Math.random() * 1000)// random() 方法可返回介于 0 ~ 1 之间的一个随机数。
}

export function initSocket(callback) {
  let retryCount = 0
  const socket = createConnect()
  socket.on('connect', () => {
    // 监听连接是否成功
    console.log('connect')
  })

  socket.on('disconnect', (reason) => {
    // 监听连接异常中断
    console.log(reason)
  })
  socket.on('connect_error', (e) => {
    retryCount++
    // 关闭连按
    socket.close()
    setTimeout(() => {
      socket.connect()
    }, nextDelayTime(retryCount))
  })

  whatsAppSocket(socket)
}

